import $ from 'jquery';

import { getWmProjectProperties } from './wm-project-properties';
import { setAttr } from "./dom";
import {
  forEach,
  toUpper,
  isArray,
  isNull,
  isString,
  isUndefined,
  isEmpty,
  groupBy,
  includes,
  get,
  isFunction,
  toLower,
  sortBy,
  cloneDeep,
  startsWith,
  camelCase,
  isEqual,
  split,
  map,
  assignWith,
  extend,
  head, last, isDate,
  capitalize
} from "lodash-es";
import moment from "moment";
import { DataType } from './enums';
import { Subject } from 'rxjs';
import { $watch } from './watcher';
import { DataSource, runtimeEventManager } from '../public-api';
import { DatePipe } from '@angular/common';
import { DEFAULT_FORMATS } from "./enums";

declare const cordova: any;

const userAgent = window.navigator.userAgent;
const REGEX = {
  SNAKE_CASE: /[A-Z]/g,
  ANDROID: /Android/i,
  IPHONE: /iPhone/i,
  IPOD: /iPod/i,
  IPAD: /iPad/i,
  MAC: /Mac/i,
  ANDROID_TABLET: /android|android 3.0|xoom|sch-i800|playbook|tablet|kindle/i,
  MOBILE: /Mobile/i,
  WINDOWS: /Windows Phone/i,
  SUPPORTED_IMAGE_FORMAT: /\.(bmp|gif|jpe|jpg|jpeg|tif|tiff|pbm|png|ico)$/i,
  SUPPORTED_FILE_FORMAT: /\.(txt|js|css|html|script|properties|json|java|xml|smd|xmi|sql|log|wsdl|vm|ftl|jrxml|yml|yaml|md|less|jsp)$/i,
  SUPPORTED_AUDIO_FORMAT: /\.(mp3|ogg|webm|wma|3gp|wav|m4a)$/i,
  SUPPORTED_VIDEO_FORMAT: /\.(mp4|ogg|webm|wmv|mpeg|mpg|avi|mov)$/i,
  PAGE_RESOURCE_PATH: /^\/pages\/.*\.(js|css|html|json)$/,
  MIN_PAGE_RESOURCE_PATH: /.*(page.min.html)$/,
  VALID_EMAIL: /^[a-zA-Z][\w.+]+@[a-zA-Z_]+?\.[a-zA-Z.]{1,4}[a-zA-Z]$/,
  VALID_WEB_URL: /^(http[s]?:\/\/)(www\.){0,1}[a-zA-Z0-9=:?\/\.\-]+(\.[a-zA-Z]{2,5}[\.]{0,1})?/,
  VALID_WEBSOCKET_URL: /^(ws[s]?:\/\/)(www\.){0,1}[a-zA-Z0-9=:?\/\.\-]+(\.[a-zA-Z]{2,5}[\.]{0,1})?/,
  VALID_RELATIVE_URL: /^(?!www\.|(?:http|ftp)s?:\/\/|[A-Za-z]:\\|\/\/).*/,
  REPLACE_PATTERN: /\$\{([^\}]+)\}/g,
  ZIP_FILE: /\.zip$/i,
  EXE_FILE: /\.exe$/i,
  NO_QUOTES_ALLOWED: /^[^'|"]*$/,
  NO_DOUBLE_QUOTES_ALLOWED: /^[^"]*$/,
  VALID_HTML: /<[a-z][\s\S]*>/i,
  VALID_PASSWORD: /^[0-9a-zA-Z-_.@&*!#$%]+$/,
  SPECIAL_CHARACTERS: /[^A-Z0-9a-z_]+/i,
  APP_SERVER_URL_FORMAT: /^(http[s]?:\/\/)(www\.){0,1}[a-zA-Z0-9\.\-]+([:]?[0-9]{2,5}|\.[a-zA-Z]{2,5}[\.]{0,1})\/+[^?#&=]+$/,
  JSON_DATE_FORMAT: /\d{4}-[0-1]\d-[0-3]\d(T[0-2]\d:[0-5]\d:[0-5]\d.\d{1,3}Z$)?/,
  DATA_URL: /^\s*data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s]*)\s*$/i
},
  compareBySeparator = ':';

const NUMBER_TYPES = ['int', DataType.INTEGER, DataType.FLOAT, DataType.DOUBLE, DataType.LONG, DataType.SHORT, DataType.BYTE, DataType.BIG_INTEGER, DataType.BIG_DECIMAL];

export const noop = (...args: any[]) => { };

export let _WM_APP_PROJECT: any = {};

export const isObject = (v: any) => null !== v && 'object' === typeof v;

export const toBoolean = (val: any, identity?: any) => ((val && val !== 'false') ? true : (identity ? val === identity : false));

function isIE11() {
  return window.navigator.appVersion.indexOf('Trident/') > -1;
}

export const isIE = () => {
  return isIE11() || window.navigator.userAgent.indexOf('MSIE') > -1;
};


export const isAndroid = () => REGEX.ANDROID.test(userAgent);

export const isAndroidTablet = () => REGEX.ANDROID_TABLET.test(userAgent) && !((/Tablet PC 2.0/i).test(userAgent));

export const isIphone = () => REGEX.IPHONE.test(userAgent);
export const isIpod = () => REGEX.IPOD.test(userAgent);
export const isIpad = () => {
  return REGEX.IPAD.test(userAgent) || (window.navigator.maxTouchPoints && window.navigator.maxTouchPoints > 2 && REGEX.MAC.test(window.navigator.platform));
};

export const isIos = () => isIphone() || isIpod() || isIpad();

export const isLargeTabletLandscape = () => window.matchMedia("only screen and (min-device-width : 1366px) and (max-device-width : 1366px) and (min-device-height : 1024px) and (max-device-height : 1024px) and (min-width: 1366px) and (max-width: 1366px)").matches;

export const isLargeTabletPortrait = () => window.matchMedia("only screen and (min-device-width : 1024px) and (max-device-width : 1024px) and (min-device-height : 1366px) and (max-device-height : 1366px) and (min-width: 1024px) and (max-width: 1024px)").matches;

export const isMobile = () => isAndroid() || isIos() || isAndroidTablet() || $('#wm-mobile-display:visible')?.length > 0;

export const isTablet = () => {
  const el = document.querySelector('.app-page');
  const scope = get(el, 'widget');
  return scope && get(scope, 'viewParent.Viewport.isTabletType');
};

export const isMobileApp = () => (getWmProjectProperties().platformType === 'MOBILE' || getWmProjectProperties().platformType === 'NATIVE_MOBILE') && getWmProjectProperties().type === 'APPLICATION';

export const getAndroidVersion = () => {
  const match = (window.navigator.userAgent.toLowerCase()).match(/android\s([0-9\.]*)/);
  return match ? match[1] : '';
};

export const isKitkatDevice = () => isAndroid() && parseInt(getAndroidVersion(), 10) === 4;

export const isValidWebURL = (url: string): boolean => {
  return (REGEX.VALID_WEB_URL).test(url);
};

// this method checks if a given string starts with the given string
export const stringStartsWith = (str: string, startsWith: string, ignoreCase?: boolean): boolean => {
  if (!str) {
    return false;
  }

  const regEx = new RegExp('^' + startsWith, ignoreCase ? 'i' : '');

  return regEx.test(str);
};

/*Function to generate a random number*/
function random() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}

/*Function to generate a guid based on random numbers.*/
export const generateGUId = () => {
  return random() + '-' + random() + '-' + random();
};

export const stringEndsWith = (str: string, endsWith: string, ignoreCase?: boolean): boolean => {
  if (!str) {
    return false;
  }

  const regEx = new RegExp(endsWith + '$', ignoreCase ? 'i' : '');

  return regEx.test(str);
}

// this method encodes the url and returns the encoded string
export const encodeUrl = (url: string): string => {
  const index = url.indexOf('?');
  if (index > -1) {
    // encode the relative path
    url = encodeURI(url.substring(0, index)) + url.substring(index);
    // encode url params, not encoded through encodeURI
    url = encodeUrlParams(url);
  } else {
    url = encodeURI(url);
  }

  return url;
};

// this method encodes the url params and is private to the class only
export const encodeUrlParams = (url: string): string => {
  let queryParams, encodedParams = '', queryParamsString, index;
  index = url.indexOf('?');
  if (index > -1) {
    index += 1;
    queryParamsString = url.substring(index);
    // Encoding the query params if exist
    if (queryParamsString) {
      queryParams = queryParamsString.split('&');
      queryParams.forEach(function (param) {
        let decodedParamValue;
        const i: any = includes(param, '=') ? param.indexOf('=') : (param && param.length),
          paramName = param.substr(0, i),
          paramValue = param.substr(i + 1);

        // add the = for param name only when the param value exists in the given param or empty value is assigned
        if (paramValue || includes(param, '=')) {
          try {
            decodedParamValue = decodeURIComponent(paramValue);
          } catch (e) {
            decodedParamValue = paramValue;
          }
          encodedParams += paramName + '=' + encodeURIComponent(decodedParamValue) + '&';
        } else {
          encodedParams += paramName + '&';
        }
      });
      encodedParams = encodedParams.slice(0, -1);
      url = url.replace(queryParamsString, encodedParams);
    }
  }
  return url;
};

export function getDecodedData(content: string): any {
  let val;
  try {
    val = decodeURIComponent(content.replace(/\+/g, ' '));
  } catch (e) {
    val = content;
  }
  return val;
}

export const getValidJSON = (content: any) => {
  if (!content) {
    return undefined;
  }
  try {
    const parsedIntValue = parseInt(content, 10);
    /*obtaining json from editor content string*/
    return isObject(content) || !isNaN(parsedIntValue) ? content : JSON.parse(content);
  } catch (e) {
    /*terminating execution if new variable object is not valid json.*/
    return undefined;
  }
};

/*
 * Util method to find the value of a key in the object
 * if key not found and create is true, an object is created against that node
 * Examples:
 * var a = {
 *  b: {
 *      c : {
 *          d: 'test'
 *      }
 *  }
 * }
 * Utils.findValue(a, 'b.c.d') --> 'test'
 * Utils.findValue(a, 'b.c') --> {d: 'test'}
 * Utils.findValue(a, 'e') --> undefined
 * Utils.findValue(a, 'e', true) --> {} and a will become:
 * {
 *   b: {
 *      c : {
 *          d: 'test'
 *      }
 *  },
 *  e: {
 *  }
 * }
 */
export const findValueOf = (obj: any, key: any, create?: any) => {

  if (!obj || !key) {
    return;
  }

  if (!create) {
    return get(obj, key);
  }

  const parts = key.split('.'),
    keys: Array<any> = [];

  let skipProcessing;


  // @ts-ignore
  parts.forEach((part: any) => {
    if (!parts.length) { // if the part of a key is not valid, skip the processing.
      skipProcessing = true;
      return false;
    }

    const subParts = part.match(/\w+/g);
    let subPart;

    while (subParts.length) {
      subPart = subParts.shift();
      keys.push({ 'key': subPart, 'value': subParts.length ? [] : {} }); // determine whether to create an array or an object
    }
  });

  if (skipProcessing) {
    return undefined;
  }

  keys.forEach((_key) => {
    let tempObj = obj[_key.key];
    if (!isObject(tempObj)) {
      tempObj = getValidJSON(tempObj);
      if (!tempObj) {
        tempObj = _key.value;
      }
    }
    obj[_key.key] = tempObj;
    obj = tempObj;
  });

  return obj;
};

export const isDefined = (v: any) => 'undefined' !== typeof v;

// function to check if fn is a function and then execute
export function triggerFn(fn: any, ...argmnts: any[]) {
  /* Use of slice on arguments will make this function not optimizable
  * https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
  * */

  let start = 1;
  const len = arguments.length, args = new Array(len - start);
  for (start; start < len; start++) {
    args[start - 1] = arguments[start];
  }

  if (isFunction(fn)) {
    return fn.apply(null, args);
  }
}

// This method will set the given proto on the target
export const extendProto = (target: any, proto: any) => {
  let _proto = Object.getPrototypeOf(target);
  while (Object.getPrototypeOf(_proto).constructor !== Object) {
    _proto = Object.getPrototypeOf(_proto);
    // return if the prototype of created component and prototype of context are same
    if (proto === _proto) {
      return;
    }
  }
  Object.setPrototypeOf(_proto, proto);
};

/*
 * Util method to replace patterns in string with object keys or array values
 * Examples:
 * Utils.replace('Hello, ${first} ${last} !', {first: 'wavemaker', last: 'ng'}) --> Hello, wavemaker ng
 * Utils.replace('Hello, ${0} ${1} !', ['wavemaker','ng']) --> Hello, wavemaker ng
 * Examples if parseError is true:
 * Utils.replace('Hello, {0} {1} !', ['wavemaker','ng']) --> Hello, wavemaker ng
 */
export const replace = (template: string, map: any, parseError?: boolean) => {
  let regEx = REGEX.REPLACE_PATTERN;
  if (!template) {
    return;
  }
  if (parseError) {
    regEx = /\{([^\}]+)\}/g;
  }

  return template.replace(regEx, function (match, key) {
    return get(map, key);
  });
};


export const isNumber = (v: any) => typeof v === 'number';

export const isBoolean = (v: any) => typeof v === 'boolean';

export const hasCordova = () => {
  return !!get(window, 'cordova');
};

export const transformFileURI = (url: string) => {
  if (url && hasCordova() && url.startsWith('file://')) {
    if (isIos()) {
      return url.replace('file://', '/_app_file_');
    } else if (isAndroid() && location.href.startsWith('http')) {
      if (url.startsWith(cordova.file.applicationDirectory)) {
        return url.replace(cordova.file.applicationDirectory + 'www', '');
      } else if (url.startsWith('file://')) {
        return url.replace('file://', '/_app_file_');
      }
    }
  }
  return url;
};

/**
 * This function gets session storage item based on the project ID
 * @param key string
 */
export const getSessionStorageItem = (key: string): any => {
  // sanity check for this to work with ng-codegen
  let item = window && window.sessionStorage && window.sessionStorage.getItem(_WM_APP_PROJECT.id);

  if (item) {
    item = JSON.parse(item);
    return get(item, key);
  }
};
export const getClonedObject = (object: any) => {
  return cloneDeep(object);
};

export const initCaps = (name: string) => {
  if (!name) {
    return '';
  }
  return name.charAt(0).toUpperCase() + name.substring(1);
}

let servicesMap: { [key: string]: string } = {
  'TypeUtils': 'TypeFactoryService'
}

export const getService = (serviceName: any) => {
  if (!serviceName) {
    return;
  }
  /* get a reference to the element where ng-app is defined */
  var appEl = $('[id=ng-app]'), injector;
  if (appEl) {
    try {
      return runtimeEventManager.getService(servicesMap[serviceName]);
    } catch (e) {
      return undefined;
    }
  }
}


// Generate for attribute on label and ID on input element, so that label elements are associated to form controls
export const addForIdAttributes = (element: HTMLElement) => {
  const labelEl = element.querySelectorAll('label.control-label');
  let inputEl = element.querySelectorAll('[focus-target]');
  if (!inputEl.length) {
    inputEl = element.querySelectorAll('input, select, textarea');
  }
  /*if there are only one input el and label El add id and for attribute*/
  if (labelEl.length && inputEl.length) {
    const widgetId = $(inputEl[0] as HTMLElement).closest('[widget-id]').attr('widget-id');
    if (widgetId) {
      setAttr(inputEl[0] as HTMLElement, 'id', widgetId);
      setAttr(labelEl[0] as HTMLElement, 'for', widgetId);
    }
  }
};

/**
 * This method is used to get the formatted date
 */
export const getFormattedDate = (datePipe: DatePipe, dateObj: any, format: string): any => {
  if (!dateObj) {
    return undefined;
  }
  if (format === 'timestamp') {
    return moment(dateObj).valueOf();
  }
  return datePipe.transform(dateObj, format);
};

/*  This function returns javascript date object*/
export const getNativeDateObject = (val: any, options?: any) => {
  val = getValidDateObject(val, options);
  return new Date(val);
};

// @ts-ignore
const momentPattern = (pattern): string => {
  if (includes(pattern, 'E')) {
    // @ts-ignore
    pattern =  replace(pattern, /E[,]?/g, '');
  }
  // @ts-ignore
  return replace(pattern!, /y*d*/g, (val) => val.toUpperCase());
};

/*  This function returns date object. If val is undefined it returns invalid date */
export const getValidDateObject = (val: any, options?: any) => {
  const defaultMeridian = ['AM', 'PM'];
  const Meridian = get(moment(), '_locale')
  const momentMeridian = get(Meridian, '_meridiemParse')
  // Updating localized meridians with default meridians when moment meridian is not defined
  if (options && options.meridians && includes(defaultMeridian, momentMeridian)) {
    forEach(options.meridians, (meridian, index: any) => {
      if (includes(val, meridian)) {
        val = val.replace(meridian, defaultMeridian[index]);
      }
    });
  }
  const isNativePicker = (options && options.hasOwnProperty('isNativePicker')) ? get(options, 'isNativePicker') : isMobile();
  const pattern = isNativePicker ? (get(options, 'pattern') || 'YYYY/MM/DD HH:mm:ss') : (momentPattern(get(options, 'pattern')) || '');
  // Handling localization
  if (options && options.pattern && options.pattern !== 'timestamp') {
    if (!isNaN((new Date(val)).getTime())) {
      // check whether val is a valid date or not
      if (isIos()) {
        // For iOS, explicitly setting the format to consider even the seconds.
        val = moment(val).format('YYYY/MM/DD HH:mm:ss');
      }
      val = moment(new Date(val), pattern);
    } else {
      val = moment(val, pattern);
    }
    val = val.toDate();
  }

  /*if the value is a timestamp string, convert it to a number*/
  if (!isNaN(val)) {
    val = parseInt(val, 10);
  } else {
    /*if the value is in HH:mm:ss format, it returns a wrong date. So append the date to the given value to get date*/
    if (!(new Date(val).getTime())) {
      val = moment((moment().format('YYYY-MM-DD') + ' ' + val), 'YYYY-MM-DD HH:mm:ss A');
    }
  }
  return new Date(moment(val).valueOf());
}

export const getDateObj = (value: any, options?: any) => {
  // Handling localization
  if (options && options.pattern && options.pattern !== 'timestamp') {
    // Fix for WMS-19601, invalid date is returned on date selection.
    const isNativePicker = (options && options.hasOwnProperty('isNativePicker')) ? get(options, 'isNativePicker') : isMobile();
    const pattern: any = isNativePicker ? 'YYYY/MM/DD HH:mm:ss' : momentPattern(options.pattern);
    value = moment(value, pattern).toDate();
  }
  /*if the value is a date object, no need to covert it*/
  if (isDate(value)) {
    return value;
  }

  /*if the value is a timestamp string, convert it to a number*/
  if (!isNaN(value)) {
    value = parseInt(value, 10);
  }

  if (!moment(value).isValid() || value === '' || value === null || value === undefined) {
    return undefined;
  }
  let dateObj = new Date(value);
  /**
   * if date value is string "20-05-2019" then new Date(value) return 20May2019 with current time in India,
   * whereas this will return 19May2019 with time lagging for few hours.
   * This is because it returns UTC time i.e. Coordinated Universal Time (UTC).
   * To create date in local time use moment
   */
  if (isString(value)) {
    /*
     * If selected locale is Arabic, moment(value).format() is giving date in Arabic language
     * (Ex: If date value is "1990-11-23" and moment(value).format() is "١٩٩٠-١١-٢٣T٠٠:٠٠:٠٠+٠٥:٣٠")
     * and new Date(moment(value).format()) is giving Invalid Date. So frst converting it to timestamp value.
    */

    dateObj = new Date(moment(moment(value).format()).valueOf());
  }

  if (value === 'CURRENT_DATE' || isNaN(dateObj.getDay())) {
    return new Date();
  }
  return dateObj;
}
const DEFAULT_DISPLAY_FORMATS: any = {
  DATE: 'yyyy-MM-dd',
  TIME: 'hh:mm a',
  TIMESTAMP: 'yyyy-MM-dd hh:mm:ss a',
  DATETIME: 'yyyy-MM-dd hh:mm:ss a',
}
// This method returns the display date format for given type
export const getDisplayDateTimeFormat = (type: any) => {

  return DEFAULT_DISPLAY_FORMATS[toUpper(type)];
};

export const createArrayFrom = (data: any): Array<any> => {

  if (isUndefined(data) || isNull(data)) {
    return [];
  }

  if (isString(data)) {
    data = data.split(',').map(Function.prototype.call, String.prototype.trim);
  }

  else if (isArray(data)) {
    data = [data];
  }

  return data;
};

export const isResolveConflictsExists = (actionResponse: any) => {
  var conflictsFlag = false,
    actionsInfo;
  if (!isEmpty(actionResponse)) {
    actionsInfo = groupBy(actionResponse, 'type');
    if (actionsInfo['RESOLVE_CONFLICTS'] || actionsInfo['APPLY_MERGE_CHANGES']) {
      conflictsFlag = true;
    }
  }
  return conflictsFlag;
}

export const isInsecureContentRequest = (url: string): boolean => {

  const parser: HTMLAnchorElement = document.createElement('a');
  parser.href = url;

  // for relative urls IE returns the protocol as empty string
  if (parser.protocol === '') {
    return false;
  }

  // If the inputted source is a base64 url, do not throw insecure content error
  if (REGEX.DATA_URL.test(url)) {
    return false;
  }

  if (stringStartsWith(location.href, 'https://')) {
    return parser.protocol !== 'https:' && parser.protocol !== 'wss:';
  }

  return false;
};
/*
* extracts and returns the last bit from full typeRef of a field
* e.g. returns 'String' for typeRef = 'java.lang.String'
* @params: {typeRef} type reference
*/
export const extractType = (typeRef: string): string => {
  let type;
  if (!typeRef) {
    return DataType.STRING;
  }
  type = typeRef && typeRef.substring(typeRef.lastIndexOf('.') + 1);
  type = type && type.toLowerCase();
  type = type === DataType.LOCALDATETIME ? DataType.DATETIME : type;
  return type;
};

export const getDateTimeFormatForType = (type: string) => {
  return DEFAULT_FORMATS[type.toUpperCase()];
};

/*Function to check if date time type*/
export const isDateTimeType = (type: any) => {
  if (includes(type, '.')) {
    type = toLower(extractType(type));
  }
  return includes([DataType.DATE, DataType.TIME, DataType.TIMESTAMP, DataType.DATETIME, DataType.LOCALDATETIME], type);
};

/* returns true if the provided data type matches number type */
export const isNumberType = (type: any): boolean => {
  return (NUMBER_TYPES.indexOf(extractType(type).toLowerCase()) !== -1);
};

export const AppConstants = {
  INT_MAX_VALUE: 2147483647
};

/**
 * This method is to get datsource from the expression
 * @param expr - expression of the dataset
 * @param scope - scope of the widget
 * Example1: expr - "Variables.staticVar1.dataSet.details[$i].addresses" then the method will return datasource as Variables.staticVar1
 * Example2: expr - "Widgets.list1.currentItem.addresses" and list1 is bound to "Variables.staticVar1.dataSet.details" then the method will return datasource as Variables.staticVar1
 */
export const getDatasourceFromExpr = (expr: any, scope: any): any => {
  const isBoundToVariable = startsWith(expr, 'Variables.');
  const isBoundToWidget = startsWith(expr, 'Widgets.');
  const parts = expr.split('.');
  if (isBoundToVariable) {
    return get(scope.viewParent.Variables, parts[1]);
  }
  if (isBoundToWidget) {
    const widgetScope = get(scope.viewParent.Widgets, parts[1]);
    const widgetDatasetBoundExpr = widgetScope.$attrs.get('datasetboundexpr');
    let widgetBoundExpression;
    widgetBoundExpression = (!widgetScope.datasource && widgetDatasetBoundExpr) ? widgetDatasetBoundExpr : widgetScope.binddataset;
    return getDatasourceFromExpr(widgetBoundExpression, widgetScope);
  }
};

/**
 * This traverses the filterexpressions object recursively and process the bind string if any in the object
 * @param variable variable object
 * @param name name of the variable
 * @param context scope of the variable
 */
export const processFilterExpBindNode = (context: any, filterExpressions: any) => {
  const destroyFn = context.registerDestroyListener ? context.registerDestroyListener.bind(context) : noop;
  const filter$ = new Subject();

  const bindFilExpObj = (obj: any, targetNodeKey: any) => {
    if (stringStartsWith(obj[targetNodeKey], 'bind:')) {
      // [Todo-CSP]: needs a check, where is this used
      destroyFn(
        $watch(obj[targetNodeKey].replace('bind:', ''), context, {}, (newVal: any, oldVal: any) => {
          if ((newVal === oldVal && isUndefined(newVal)) || (isUndefined(newVal) && !isUndefined(oldVal))) {
            return;
          }
          // Skip cloning for blob column
          if (!includes(['blob', 'file'], obj.type)) {
            newVal = cloneDeep(newVal);
          }
          // backward compatibility: where we are allowing the user to bind complete object
          if (obj.target === 'dataBinding') {
            // remove the existing databinding element
            filterExpressions.rules = [];
            // now add all the returned values
            forEach(newVal, function (value, target) {
              filterExpressions.rules.push({
                'target': target,
                'value': value,
                'matchMode': obj.matchMode || 'startignorecase',
                'required': false,
                'type': ''
              });
            });
          } else {
            // setting value to the root node
            obj[targetNodeKey] = newVal;
          }
          filter$.next({ filterExpressions, newVal });
        }, undefined, false, { arrayType: includes(['in', 'notin'], obj.matchMode) })
      );
    }
  };

  const traverseFilterExpressions = (expressions: any) => {
    if (expressions.rules) {
      forEach(expressions.rules, (filExpObj, i) => {
        if (filExpObj.rules) {
          traverseFilterExpressions(filExpObj);
        } else {
          if (filExpObj.matchMode === 'between') {
            bindFilExpObj(filExpObj, 'secondvalue');
          }
          bindFilExpObj(filExpObj, 'value');
        }
      });
    }
  };
  traverseFilterExpressions(filterExpressions);

  return filter$;
};

export const prettifyLabel = (label: any) => {
  label = camelCase(label);
  /*capitalize the initial Letter*/
  label = initCaps(label);
  /*Convert camel case words to separated words*/
  label = spaceSeparate(label);
  /*Replace '.' with space and capitalize the next letter*/
  label = periodSeparate(label);
  return label;
};

export const deHyphenate = (name: string) => {
  return name.split('-').join(' ');
};

/* convert camelCase string to a space separated string */
export const spaceSeparate = (name: any) => {
  if (name === name.toUpperCase()) {
    return name;
  }
  return name.replace(REGEX.SNAKE_CASE, (letter: any, pos: any) => {
    return (pos ? ' ' : '') + letter;
  });
};

/*Replace '.' with space and capitalize the next letter*/
export const periodSeparate = (name: any) => {
  let dotIndex;
  dotIndex = name.indexOf('.');
  if (dotIndex !== -1) {
    name = replaceAt(name, dotIndex + 1, name.charAt(dotIndex + 1).toUpperCase());
    name = replaceAt(name, dotIndex, ' ');
  }
  return name;
};

export const replaceAt = (string: any, index: any, character: any) => string.substr(0, index) + character + string.substr(index + character.length);

/**
 * This method is to get dataset bound expression from list currentitem expression
 * @param expr - bound dataset expression
 * @param scope - scope of the widget
 * Example1: expr - "Widgets.list1.currentItem.details" and list1 is bound to "Variables.staticVar1.dataSet" then it returns expression as "Variables.staticVar1.dataSet[$i].details"
 */
export const extractCurrentItemExpr: any = (expr: any, scope: any) => {
  const currentItemRegEx = /^Widgets\..*\.currentItem/g;
  if (currentItemRegEx.test(expr)) {
    const parts = expr.split('.');
    const widgetScope = get(scope.viewParent.Widgets, parts[1]);
    const widgetDatasetBoundExpr = widgetScope.$attrs.get('datasetboundexpr');
    if (!widgetScope.datasource && widgetDatasetBoundExpr) {
      expr = expr.replace(/^Widgets\..*\.currentItem/g, `${widgetDatasetBoundExpr}[$i]`);
      return extractCurrentItemExpr(expr, scope);
    } else {
      expr = expr.replace(/^Widgets\..*\.currentItem/g, `${widgetScope.binddataset}[$i]`);
    }
  }
  return expr;
};

/**
 * This function accepts two data sources and will check if both are same by comparing the unique id and
 * context in which datasources are present
 * @returns {*} boolean true/ false
 */
export const isDataSourceEqual = (d1: any, d2: any) => {
  return d1.execute(DataSource.Operation.GET_UNIQUE_IDENTIFIER) === d2.execute(DataSource.Operation.GET_UNIQUE_IDENTIFIER) &&
    isEqual(d1.execute(DataSource.Operation.GET_CONTEXT_IDENTIFIER), d2.execute(DataSource.Operation.GET_CONTEXT_IDENTIFIER));
};
export const prettifyLabels = (names: any, separator = ',') => {
  let modifiedNames, namesArray: any[] = [];

  if (!isArray(names)) {
    namesArray = split(names, separator);
  }

  modifiedNames = map(namesArray, prettifyLabel);
  if (isArray(names)) {
    return modifiedNames;
  }
  return modifiedNames.join(separator);
};

export function getPropertyNode(prop: any) {
  return {
    'type': prop.type,
    'isPrimaryKey': prop.isPrimaryKey,
    'generator': prop.generator,
    'isRelatedPk': prop.isRelatedPk,
    'systemUpdated': prop.systemUpdated,
    'systemInserted': prop.systemInserted,
    'relatedEntityName': prop.relatedEntityName,
    'notNull': prop.notNull,
    'defaultValue': prop.defaultValue,
    'period': prop.period
  };
}

export const fetchPropertiesMapColumns = (propertiesMap: any, namePrefix?: any, options?: any) => {
  var objects: any = {}, relatedColumnsArr: any = [], terminals: any = {}, info,
    columns = getClonedObject(propertiesMap.columns);

  /* iterated trough the propertiesMap columns of all levels and build object with columns having required configuration*/
  forEach(columns, function (val) {
    /* if the object is nested type repeat the above process for that nested object through recursively */
    if (val.isRelated) {
      if (val.isList) {
        return;
      }
      relatedColumnsArr.push(val);
    } else {
      /* otherwise build object with required configuration */
      var columnName = namePrefix ? namePrefix + '.' + val.fieldName : val.fieldName;
      terminals[columnName] = getPropertyNode(val);
      if (propertiesMap.isRelated) {
        //For related columns, set not null as true for primary keys and not null
        terminals[columnName].notNull = propertiesMap.notNull && val.notNull && val.isPrimaryKey;
      }
    }
  });
  forEach(relatedColumnsArr, function (val) {
    //If a related column doesn't have further columns in it the adding the current column and returning
    if (isEmpty(val.columns)) {
      var relColumnName = namePrefix ? namePrefix + '.' + val.relatedColumnName : val.relatedColumnName;
      terminals[relColumnName] = getPropertyNode(val);
      return;
    }
    forEach(val.columns, function (col) {
      if (val.isRelated) {
        if (col.isPrimaryKey) {
          col.isRelatedPk = 'true';
        }
        col.relatedEntityName = val.relatedEntityName;
      }
    });

    var columnName = namePrefix ? namePrefix + '.' + val.fieldName : val.fieldName;
    objects[columnName] = getPropertyNode(val);
    info = fetchPropertiesMapColumns(val, val.fieldName, options);

    if (!options || (options && !options.filter)) {
      //Extend the terminal object with the inner columns. If already present, ignore them.
      assignWith(terminals, info, function (objValue, srcValue) {
        return isUndefined(objValue) ? srcValue : objValue;
      });
    } else {
      switch (options.filter) {
        case 'all':
          extend(terminals, info.terminals);
          extend(objects, info.objects);
          break;
        case 'objects':
          extend(objects, info);
          break;
        case 'terminals':
          extend(terminals, info);
          break;
      }
    }
  });

  if (!options || (options && !options.filter)) {
    return terminals;
  }
  switch (options.filter) {
    case 'all':
      return { 'objects': objects, 'terminals': terminals };
    case 'objects':
      return objects;
    case 'terminals':
      return terminals;
  }
}

/* function to check if provided object is empty*/
export const isEmptyObject = (obj: any): boolean => {
  if (isObject(obj) && !isArray(obj)) {
    return Object.keys(obj).length === 0;
  }
  return false;
};



export const getVariableNameFromExpr = (expr: any) => {
  var variableRegex = /^bind:Variables\.(.*)\.dataSet/,
    matchValue = expr.match(variableRegex);
  return matchValue && matchValue[1];
}

export function getVariableName(iScope: any, scope?: any): any {
  if (iScope && iScope.binddataset) {
    let variableName,
      widgetScope,
      widgetName,
      isBoundToVariable,
      isBoundToWidget,
      parts = iScope.binddataset.split('.');

    isBoundToVariable = includes(iScope.binddataset, 'Variables.');

    if (!isBoundToVariable) {
      isBoundToWidget = includes(iScope.binddataset, 'Widgets.');
    }

    if (isBoundToVariable) {
      variableName = parts[1];
    } else if (isBoundToWidget) {
      if (isString(iScope.binddataset) && iScope.binddataset !== '') {
        if (!includes(iScope.binddataset, '.selecteditem')) {
          widgetName = parts[1];
          widgetScope = (scope || iScope).viewParent.Widgets[widgetName];
          variableName = getVariableName(widgetScope);
        } else {
          // Return null if widget is bound to selecteditem.something.
          variableName = null;
        }
      }
    }
    return variableName;
  }
}


/**
 * Returns the types array for particular type of widgets
 * @param type of widgets
 * @returns [string]
 */
export const getTypes = (type: any) => {
  var types: any = [];

  if (type === 'form-widgets') {
    types = ["wm-label",
      "wm-text",
      "wm-checkbox",
      "wm-checkboxset",
      "wm-radio",
      "wm-radioset",
      "wm-textarea",
      "wm-select",
      "wm-chips",
      "wm-button",
      "wm-picture",
      "wm-anchor",
      "wm-popover",
      "wm-date",
      "wm-calendar",
      "wm-time",
      "wm-datetime",
      "wm-currency",
      "wm-number",
      "wm-colorpicker",
      "wm-slider",
      "wm-fileupload",
      "wm-table",
      "wm-livefilter",
      "wm-list",
      "wm-pagination",
      "wm-html",
      "wm-prefab",
      "wm-richtexteditor",
      "wm-search",
      "wm-menu",
      "wm-switch",
      "wm-nav",
      "wm-tree",
      "wm-liveform",
      "wm-rating",
      "wm-camera",
      "wm-barcodescanner",
      "wm-mobile-navbar ",
      "wm-chart",
      "wm-view",
      "wm-form",
      "wm-carousel",
      "wm-media-list",
      "wm-progress-circle",
      "wm-custom-widget",
      "wmx-component"
    ];
  } else if (type === 'page-container-widgets') {
    types = [
      'wm-accordionpane',
      'wm-container',
      'wm-panel',
      'wm-tabcontent',
      'wm-footer',
      'wm-header',
      'wm-left-panel',
      'wm-right-panel',
      'wm-top-nav',
      'wm-cardcontent',
      'wm-wizardstep',
      'wm-tabpane'
    ];
  } else if (type === 'dialog-widgets') {
    types = ['wm-dialog', 'wm-alertdialog', 'wm-confirmdialog', 'wm-iframedialog', 'wm-pagedialog', 'wm-logindialog'];
  } else if (type === 'spinner-widgets') {
    types = [
      "wm-checkboxset",
      "wm-radioset",
      "wm-calendar",
      "wm-table",
      "wm-livefilter",
      "wm-list",
      "wm-tree",
      "wm-liveform",
      "wm-chart",
      "wm-view",
      "wm-form",
      "wm-carousel",
      "wm-media-list",
      'wm-accordionpane',
      'wm-container',
      'wm-panel',
      'wm-tabcontent',
      'wm-left-panel',
      'wm-right-panel',
      'wm-top-nav',
      'wm-cardcontent',
      'wm-wizardstep',
      'wm-tabpane'
    ];
  }
  return types;
}

export function getBoundWidgetDetails(bindDataSet: any, WidgetScopes: any) {
  let widgetName: any,
    relatedFieldName,
    bindDataSetSplit,
    referenceWidget,
    widgetRegEx = /Widgets./g,
    isBoundToSelectedItemSubset = bindDataSet.indexOf('selecteditem.') !== -1;
  //Get the reference widget name. As widget can be inner widget (like Widgets.tab.Widgets.grid), find the last inner widget
  while (widgetRegEx.exec(bindDataSet) !== null) {
    bindDataSetSplit = split(bindDataSet.substring(widgetRegEx.lastIndex, bindDataSet.length), '.');
    widgetName = head(bindDataSetSplit);
    relatedFieldName = isBoundToSelectedItemSubset && last(bindDataSetSplit);
    referenceWidget = get(WidgetScopes, widgetName);
    WidgetScopes = referenceWidget && referenceWidget.Widgets;
  }
  return {
    'widgetName': widgetName,
    'relatedFieldName': relatedFieldName,
    'referenceWidget': referenceWidget,
    'WidgetScopes': WidgetScopes
  }
}

declare global {
  interface JQueryStatic {
    cachedScript(url: string, options?: any): any;
  }
}
(function ($) {
  $.cachedScript = (() => {
    const inProgress = new Map();
    const resolved = new Set();

    const isInProgress = (url: string) => inProgress.has(url);
    const isResolved = (url: string) => resolved.has(url);
    const onLoad = (url: string) => {
      resolved.add(url);
      inProgress.get(url).resolve();
      inProgress.delete(url);
    };

    const setInProgress = (url: string) => {
      let resFn;
      let rejFn;
      const promise: any = new Promise((res, rej) => {
        resFn = res;
        rejFn = rej;
      });

      promise.resolve = resFn;
      promise.reject = rejFn;

      inProgress.set(url, promise);
    };

    return function (url) {
      if (isResolved(url)) {
        return Promise.resolve();
      }

      if (isInProgress(url)) {
        return inProgress.get(url);
      }

      setInProgress(url);

      const options = {
        dataType: 'script',
        cache: true,
        url
      };

      $.ajax(options).done(() => onLoad(url));

      return inProgress.get(url);
    };
  })();
})(jQuery);

/**
* checks if the passed datasource context matches with passed context
* @param ds, datasource having a context
* @param ctx, context to compare with
* @returns {boolean}
*/
export const validateDataSourceCtx = (ds: any, ctx: any) => {
  return ds.execute(DataSource.Operation.GET_CONTEXT_IDENTIFIER) === ctx;
};

export const getDataSource = (dataSetExpr: string = ''): string | undefined => {
  const parts = dataSetExpr.split('.');
  if (parts[0] === 'Variables' || parts[0] === 'Widgets') {
    return `${parts[0]}.${parts[1]}`;
  }
  return;
};

export const isValidXFrameUrls = (urls: any) => {
  let noOfValidUrls = 0,
    urlsArray = urls.split(',');
  urlsArray.forEach((url: any) => { if (isValidWebURL(url)) { noOfValidUrls++; } });
  return (noOfValidUrls === urlsArray.length);
}

export const getWidgetMarkup = (field: any) => {
  let widget, widgetMarkup, widgetnameMarkup = '';
  if(field.widget.widgetType) {
    widget            = field.widget.widgetType.replace('wm-', '');
    widgetnameMarkup  = 'widgetname="' + field.widget.defaults.widgetName + '" '
  } else {
    widget = field.widget;
  }
  widgetMarkup  = 'widget="' + (widget || 'text') + '" ' + widgetnameMarkup;
  return widgetMarkup;
}

export const isValidWebSocketURL = (url:string) : boolean => {
  return REGEX.VALID_WEBSOCKET_URL.test(url)
}

/**
 * returns the main canvas element containing all the page content
 * If the canvas is rendered inside the Shadow DOM, fetches it from there and returns
 * Else simply finds the element in the main Light DOM and returns
 */
export const getCanvasElement = () : any => {
  const shadowHost = document.querySelector('wms-canvas-sandbox-wrapper');
  return shadowHost?.shadowRoot ? shadowHost.shadowRoot.querySelector('.domcontent') : document.querySelector('.domcontent');
}

/**
 * Get fields required for widgetConfigDialog
 * @param data - Fields objects fromTypeUtils
 */
export const getFieldsForService = (data: any) => {
  let getModifiedName = (name: string) => {
    if (includes(name, '.')) {
      let lastIndex = name.lastIndexOf('.');
      return capitalize(name.substring(0, lastIndex)) + ' ' + prettifyLabel(name.substring(lastIndex + 1));
    }
    return prettifyLabel(name);
  };
  return map(data, (val) => {
    let modifiedName = getModifiedName(val?.field);
    return {
      'displayName': modifiedName,
      'field': val?.field,
      'relatedField': modifiedName,
      'type': val?.dataType
    };
  });
}

/*set empty values to all properties of  given object */
export const resetObjectWithEmptyValues = (object: any) => {
  let properties: any;
  if (object) {
    properties = {};
    forEach(object, (value, key) => {
      properties[key] = '';
    });
  }
  return properties;
}
